// RELÓGIO DA PARTIDA — a parte pura, partilhada pelos três ecrãs de PK.
//
// O bug que isto resolve: quando um jogador saía, escrevia `fase: "FIM",
// tempo: 0`; ao mesmo tempo o árbitro (o outro jogador, ou ele próprio, com o
// intervalo ainda vivo) mandava um `increment(-1)` que já ia a caminho. O
// servidor somava os dois e o relógio ficava em -1 — no ecrã aparecia "-1:-1".
//
// Duas defesas:
//   1. proximoTique(): o desconto passa a ser feito numa transação que lê a
//      partida primeiro; se entretanto acabou ou parou, não desconta.
//   2. formatarTempo(): o que se mostra nunca é negativo, aconteça o que
//      acontecer aos dados.

const FASES_SEM_RELOGIO = new Set(['ESPERA', 'FIM']);

// Decide o que o tique do relógio deve escrever, dado o estado ATUAL da
// partida (lido dentro da transação). Devolve null quando não há nada a
// descontar: partida inexistente, parada, terminada ou já a zero.
export function proximoTique(partida) {
  if (!partida) return null;
  if (FASES_SEM_RELOGIO.has(partida.fase)) return null;
  const tempo = Number(partida.tempo);
  if (!Number.isFinite(tempo) || tempo <= 0) return null;
  return { tempo: tempo - 1 };
}

// "M:SS", nunca abaixo de 0:00.
export function formatarTempo(tempo) {
  const t = Math.max(0, Math.floor(Number(tempo) || 0));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
}
